import { IWBSRowData } from "common/interfaces";

export class WBSRows implements IWBSRowData {
  rowType: number;
  rowIndex: number;
  description?: string;
  total?: number;
  parentStage?: string | number;
  parentTask?: string;
  contentId?: string;
  quantity?: number;
  unit?: string;
  unitCost?: number;
  contentType?: number;
  rowCode?: string;
  formula?: string;
  rateLibraryId?: string;
  rateLibraryName?: string;
  rateLibraryCode?: string;
  fromModelMap?: string;
  takeOffQuantity?: Array<string>;
  modelMapFull?: boolean;
  modelMapDescription?: string;
  customProperties?: object;
  vendaBdi?: number;
  totalBdi?: number;
  bdi?: number;
  hasCoefficient?: boolean;
  coefficient?: number;
  percentage?: number;

  constructor(
    rowType: number,
    rowIndex: number,
    description?: string,
    total?: number,
    parentStage?: number | string,
    parentTask?: string,
    contentId?: string,
    quantity?: number,
    unit?: string,
    unitCost?: number,
    contentType?: number,
    rowCode?: string,
    formula?: string,
    rateLibraryId?: string,
    rateLibraryName?: string,
    rateLibraryCode?: string,
    fromModelMap?: string,
    takeOffQuantity?: Array<string>,
    modelMapFull?: boolean,
    modelMapDescription?: string,
    customProperties?: object,
    vendaBdi?: number,
    totalBdi?: number,
    bdi?: number,
    hasCoefficient?: boolean,
    coefficient?: number,
    percentage?: number
  ) {
    this.rowType = rowType;
    this.rowIndex = rowIndex;
    if (description !== undefined) this.description = description;
    if (total !== undefined) this.total = total;
    if (parentStage !== undefined) this.parentStage = parentStage;
    if (parentTask !== undefined) this.parentTask = parentTask;
    if (contentId !== undefined) this.contentId = contentId;
    if (quantity !== undefined) this.quantity = quantity;
    if (unit !== undefined) this.unit = unit;
    if (unitCost !== undefined) this.unitCost = unitCost;
    if (contentType !== undefined) this.contentType = contentType;
    if (rowCode !== undefined) this.rowCode = rowCode;
    if (formula !== undefined) this.formula = formula;
    if (rateLibraryId !== undefined) this.rateLibraryId = rateLibraryId;
    if (rateLibraryName !== undefined) this.rateLibraryName = rateLibraryName;
    if (rateLibraryCode !== undefined) this.rateLibraryCode = rateLibraryCode;
    if (fromModelMap !== undefined) this.fromModelMap = fromModelMap;
    if (takeOffQuantity !== undefined) this.takeOffQuantity = takeOffQuantity;
    if (modelMapFull !== undefined) this.modelMapFull = modelMapFull;
    if (modelMapDescription !== undefined)
      this.modelMapDescription = modelMapDescription;
    if (customProperties !== undefined)
      this.customProperties = customProperties;
    if (vendaBdi !== undefined) this.vendaBdi = vendaBdi;
    if (totalBdi !== undefined) this.totalBdi = totalBdi;
    if (bdi !== undefined) this.bdi = bdi;
    if (percentage !== undefined) this.percentage = percentage;
  }
  public static getDefault(): WBSRows {
    return new WBSRows(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/WBSRows.tsx